// @ts-nocheck
import '@babel/polyfill'
import Vue from 'vue'
// @ts-ignore
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/assets/css/my_element.css'
import '@/assets/font/iconfont.css'
import '@/assets/font/iconfont.js'
import customComponents from '@/components/global/customComponents'

import validRule from '@/js/validRule'
import utils from '@/js/util'
import gcDIC from '@/js/globalConfigDIC'
import store from '@/store/store'
Vue.use(ElementUI)
Vue.use(customComponents)
Vue.prototype.$store = store
Vue.prototype.$validRule = validRule
Vue.prototype.$utils = utils
Vue.prototype.$gcDIC = gcDIC
new Vue({
  router,
  render: h => h(App),
  data: {
    // 中央事件总线 global event bus
    eventBus: new Vue()
  }
}).$mount('#app')
